function SubscriptionTable({ subscriptions, loading }) {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="admin-loader"></div>
      </div>
    );
  }

  if (!subscriptions || subscriptions.length === 0) {
    return (
      <div className="empty-state">
        <p className="empty-state-description">Подписки не найдены</p>
      </div>
    );
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case 'active':
        return 'badge badge-success';
      case 'expired':
        return 'badge badge-danger';
      case 'cancelled':
        return 'badge badge-gray';
      default:
        return 'badge badge-gray';
    }
  };

  const getStatusText = (status) => {
    const statusMap = {
      active: 'Активна',
      expired: 'Истекла',
      cancelled: 'Отменена',
    };
    return statusMap[status] || status;
  };

  return (
    <div className="overflow-x-auto">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Пользователь</th>
            <th>Тип</th>
            <th>Лимит</th>
            <th>Использовано</th>
            <th>Статус</th>
            <th>Истекает</th>
            <th>Сумма</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map((sub) => (
            <tr key={sub.id}>
              <td className="font-semibold">#{sub.id}</td>
              <td>
                <div className="font-medium text-gray-900">
                  {sub.first_name} {sub.last_name}
                </div>
                <div className="text-xs text-gray-500">@{sub.username || 'N/A'}</div>
              </td>
              <td className="font-medium">{sub.type}</td>
              <td className="text-gray-600">{sub.documents_limit}</td>
              <td>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-900">{sub.documents_used}</span>
                  <div className="w-16 h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-blue-500 rounded-full"
                      style={{
                        width: `${Math.min((sub.documents_used / sub.documents_limit) * 100, 100)}%`
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
                <span className={getStatusBadge(sub.status)}>
                  {getStatusText(sub.status)}
                </span>
              </td>
              <td className="text-gray-600">
                {new Date(sub.expires_at).toLocaleDateString('ru-RU', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                })}
              </td>
              <td className="font-semibold text-gray-900">
                {parseFloat(sub.amount).toLocaleString()} {sub.currency}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SubscriptionTable;

